import styled, { css } from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/material';
import { Gradient } from 'utils/types';
import { createGradientOrSolid } from 'utils';
import { EFontWeights } from 'utils/enums';

export const StyledOfferSection = styled(Box).attrs({
  className: 'offerSection',
})<{ right: number }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  right: ${({ right }) => right};
  top: 10px;
  align-items: center;
  max-width: 200px;
  height: calc(100% - 55px);

  &__header {
    &__prefix-img {
      height: 18px;
      width: 18px;
    }
    margin-top: 8px;
  }
`;

export const StyledOfferTitle = styled.div<{
  title: string;
  textColor: Gradient;
  fontSize: number;
  fontWeight: EFontWeights;
  isSubTitle: boolean;
}>`
  max-width: 200px;

  .title {
    margin: 0;
    display: block;
    white-space: nowrap;
    font-weight: ${({ fontWeight }) => fontWeight};
    background: ${({ textColor }) => createGradientOrSolid(textColor)};
    font-size: ${({ fontSize }) => fontSize}px;
    ${({ isSubTitle }) =>
      isSubTitle &&
      css`
        line-height: 1rem;
      `}
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    text-align: center;

    @media (width < ${breakpoints.mobileS}) {
      font-size: 16px;
    }

    &:after {
      background: none;
      content: '${({ title }) => CSS.escape(title || '')}';
      left: 0;
      top: 0;
      z-index: -1;
      position: absolute;
      ${({ isSubTitle }) =>
        isSubTitle &&
        css`
          line-height: 1rem;
        `}
      text-align: center;
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.8);
    }
  }
`;

export const StyledSpecialOfferPrice = styled.div`
  display: flex;
  direction: ${(props: any) => props.direction};
  justify-content: center;
  width: 100%;
  color: var(--button-text-color);
  position: relative;

  .totalPrice {
    display: flex;
    justify-content: center;
    z-index: 10;
    white-space: nowrap;

    @media (width < ${breakpoints.mobileS}) {
      font-size: 12px;
    }
  }
` as any;
